import { render, staticRenderFns } from "./PerformedSearchesSearch.vue?vue&type=template&id=28d8056e&"
import script from "./PerformedSearchesSearch.vue?vue&type=script&lang=js&"
export * from "./PerformedSearchesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports